export default {
  name: 'safetyMeeting',
  miniSave: false,
  uploadFunction: ({ requestFunction, data, saveId }) => {
    const now = new Date().toISOString().slice(0, 19).replace('T', ' ')
    const uploadData = {
      ...data,
      datestarted: data.datestarted || now,
      datefinished: data.datefinished || now,
      sops: (data.sops || []).filter(sop => sop && typeof sop === 'object' && sop.sopid != null),
    }
    return requestFunction.methodRequest(
      '/crewconfig/meeting/monthly',
      'PUT',
      uploadData
    )
  },
  restoreSave: (ctx) => {
    const data = ctx.saveObj.data
    ctx.router.push({
      name: `crews-crewid-safety-meeting-new`,
      params: { crewid: data.crewid },
      query: { sid: ctx.saveId },
    })
  },
}
